<template lang="pug">
  .obj-list.obj-list_coming-shifts
    .obj-list__item(
      v-for="shift in shiftsData"
    )
      .obj.obj_vertical
        .obj__media
          image-slider(
            :data-images="shift.photos"
          )
        router-link.obj__body(
          :to="`/pages/shifts/${shift.id}/`"
        )
          .obj__name(v-if="shift.camp") {{shift.camp.name}}
          .obj__title(

          ) {{shift.name}}
          .obj__date {{ shift.date_started | monthDayDate }} - {{ shift.date_finished | monthDayDate }}
</template>
<script>
import ImageSlider from "@/components/imageSlider/ImageSlider.vue";

export default {
  name: "ComingCampShifts",
  components: {
    ImageSlider
  },
  props: {
    sliderData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      shiftsData: [],
      sliderImages3: [
        "https://dummyimage.com/600x560/d9b0d9/000000.jpg",
        "https://dummyimage.com/600x560/5558a3/000000.jpg",
        "https://dummyimage.com/600x560/55a162/000000.jpg",
        "https://dummyimage.com/600x560/94a155/000000.jpg",
        "https://dummyimage.com/600x560/a15555/000000.jpg"
      ]
    };
  },
  methods: {
    createSliderData(data) {
      data = JSON.parse(JSON.stringify(data));
      this.shiftsData = data.map(shift => {
        if (shift.photos) {
          shift.photos = shift.photos.map(el => el.preview_376x340);
          shift.photos = shift.photos.slice(0, 5);
          // if (shift.photos.length === 0) {
          //   shift.photos = this.sliderImages3;
          // } else {
          //   shift.photos = shift.photos.map(el => el.preview_376x340);
          //   shift.photos = shift.photos.slice(0, 5);
          // }
        }
        return shift;
      });
    }
  },
  mounted() {
    this.createSliderData(this.sliderData.slice(0, 6));
  },
  watch: {
    sliderData(data) {
      this.createSliderData(data.slice(0, 6));
    }
  }
};
</script>
